import { connect, MapStateToProps } from 'react-redux';
import { Props } from './TierLayout';
import { AppState } from '../../../../types/store';
import { getPublishedTiers, getStudioParams } from '../../../../selectors/studio';

export type StateProps = Pick<Props, 'tiers' | 'tierId'>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  tiers: getPublishedTiers(state),
  tierId: getStudioParams(state).tierId,
});

export default connect(mapStateToProps);
